import basketApi from '@/api/basketApi'
import bookingApi from '@/api/bookingApi'
import outletApi from '@/api/outletApi'
import orderApi from '@/api/orderApi'
import productApi from '@/api/productApi'
import authApi from '@/api/authApi'
import webviewApi from '@/api/webviewApi'
import guardApi from '@/api/guardApi'
import smsApi from '@/api/smsApi'
import profileApi from '@/api/profileApi'
import categoryApi from '@/api/categoryApi'
import resourceApi from '@/api/resourceApi'
import resourceCategoryApi from '@/api/resourceCategoryApi'
import specialPostApi from './specialPostApi'

export default {
  basket: basketApi,
  auth: authApi,
  outlet: outletApi,
  order: orderApi,
  product: productApi,
  webview: webviewApi,
  guard: guardApi,
  sms: smsApi,
  profile: profileApi,
  category: categoryApi,
  resource: resourceApi,
  resourceCategory: resourceCategoryApi,
  specialPost: specialPostApi,
  booking: bookingApi,
}
